import { BomItemType } from 'model/Project/BoMItemRow'
import { useDeepCompareMemoize } from 'utils/useDeepCompareMemoize'

export const useBomItemPointer = (
  bomItemId: string,
  bomItemType: BomItemType,
) => {
  return useDeepCompareMemoize({
    id: bomItemId,
    type: bomItemType,
  })
}
